// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Playfair+Display:ital,wght@0,400;0,600;0,700;0,900;1,400&family=JetBrains+Mono:wght@400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #f1f5f9;
  color: #1e293b;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* BRAND LOGO STYLES */
.brand-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
}

.shield-icon {
  width: 42px;
  height: 50px;
  background: linear-gradient(135deg, #981b1e 0%, #721215 100%);
  border-radius: 4px 4px 24px 24px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(152, 27, 30, 0.25);
  flex-shrink: 0;
}

.shield-icon::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: #d4af37;
  border-radius: 4px 4px 0 0;
}

.shield-char {
  color: white;
  font-family: 'Playfair Display', serif;
  font-weight: 900;
  font-size: 28px;
  margin-top: 3px;
  font-style: italic;
}

/* Large Logo */
.shield-icon.large {
  width: 120px;
  height: 144px;
  border-radius: 8px 8px 60px 60px;
}

.shield-icon.large::before {
  height: 8px;
  border-radius: 8px 8px 0 0;
}

.shield-icon.large .shield-char {
  font-size: 80px;
  margin-top: 6px;
}

/* UI UTILITIES */
.fade-in {
  animation: fadeIn 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

/* Custom scrollbar for announcements */
.custom-scrollbar::-webkit-scrollbar {
  width: 5px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #981b1e;
  border-radius: 3px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #721215;
}

/* HERO STYLES */
.hero-bg-image {
  background-image: url('https://images.unsplash.com/photo-1523580494863-6f3031224c94?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80');
  background-size: cover;
  background-position: center 20%;
}

.hero-overlay {
  background: linear-gradient(to right, rgba(152, 27, 30, 0.95) 0%, rgba(152, 27, 30, 0.7) 60%, rgba(212, 175, 55, 0.2) 100%);
}

/* MEGA MENU */
.group:hover .mega-menu {
  display: block;
  animation: slideDown 0.2s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,4DAA4D;AAC9D;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,qIAAqI;EACrI,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,2HAA2H;AAC7H;;AAEA,cAAc;AACd;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Playfair+Display:ital,wght@0,400;0,600;0,700;0,900;1,400&family=JetBrains+Mono:wght@400&display=swap');\n\nbody {\n  background-color: #f1f5f9;\n  color: #1e293b;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* BRAND LOGO STYLES */\n.brand-logo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  text-decoration: none;\n}\n\n.shield-icon {\n  width: 42px;\n  height: 50px;\n  background: linear-gradient(135deg, #981b1e 0%, #721215 100%);\n  border-radius: 4px 4px 24px 24px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 10px rgba(152, 27, 30, 0.25);\n  flex-shrink: 0;\n}\n\n.shield-icon::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background: #d4af37;\n  border-radius: 4px 4px 0 0;\n}\n\n.shield-char {\n  color: white;\n  font-family: 'Playfair Display', serif;\n  font-weight: 900;\n  font-size: 28px;\n  margin-top: 3px;\n  font-style: italic;\n}\n\n/* Large Logo */\n.shield-icon.large {\n  width: 120px;\n  height: 144px;\n  border-radius: 8px 8px 60px 60px;\n}\n\n.shield-icon.large::before {\n  height: 8px;\n  border-radius: 8px 8px 0 0;\n}\n\n.shield-icon.large .shield-char {\n  font-size: 80px;\n  margin-top: 6px;\n}\n\n/* UI UTILITIES */\n.fade-in {\n  animation: fadeIn 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n::-webkit-scrollbar {\n  width: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n/* Custom scrollbar for announcements */\n.custom-scrollbar::-webkit-scrollbar {\n  width: 5px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 3px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background: #981b1e;\n  border-radius: 3px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb:hover {\n  background: #721215;\n}\n\n/* HERO STYLES */\n.hero-bg-image {\n  background-image: url('https://images.unsplash.com/photo-1523580494863-6f3031224c94?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80');\n  background-size: cover;\n  background-position: center 20%;\n}\n\n.hero-overlay {\n  background: linear-gradient(to right, rgba(152, 27, 30, 0.95) 0%, rgba(152, 27, 30, 0.7) 60%, rgba(212, 175, 55, 0.2) 100%);\n}\n\n/* MEGA MENU */\n.group:hover .mega-menu {\n  display: block;\n  animation: slideDown 0.2s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
